<template>
  <a-row>
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1 faq-content">
      <a-tabs
        :active-key="$route.query.tab || 'content'"
        class="main-tabs"
        type="card"
        @change="$router.push({ query: { tab: arguments[0] } })"
      >
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>

          <!-- lang tabs -->
          <a-row align="middle" class="form_title sm-mb">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
                <a-button v-if="langTab === 'oz'" @click.stop="translitAction">
                  Перевести копию на
                  {{ langTab === "uz" ? "кирилицу" : "латиницу" }}
                </a-button>
              </a-row>
            </a-col>
          </a-row>

          <!-- title -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Тема:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model.number="form.title[langTab]"
                placeholder="Введите тему"
                spellcheck="false"
              />
              <div v-if="!form.title[langTab]" class="error-text">
                Введите позицию.
              </div>
            </a-col>
          </a-row>
          <!-- position -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Позиция:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model.number="form.order"
                placeholder="Введите позицию"
                spellcheck="false"
              />
              <div v-if="!form.position" class="error-text">
                Введите позицию.
              </div>
            </a-col>
          </a-row>
          <a-row style="margin-top: 25px">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Статус:
            </a-col>
            <a-switch v-model="form.is_active" />
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import cloneDeep from "lodash/cloneDeep"
export default {
  data: () => ({
    langTab: $langPrefix,
    pending: false,
    loading: false,
    form: {
      title: {
        uz: "",
        oz: "",
        ru: "",
        en: "",
        qr: ""
      },
      order: 1,
      is_active: false
    }
  }),
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      if (!this.$route.params.id) {
        return
      }
      this.loading = true
      try {
        const r = await this.$store.dispatch(
          "faq/detailTheme",
          this.$route.params.id
        )
        this.form = {
          ...r,
          title: {
            ru: r.title_ru,
            en: r.title_en,
            oz: r.title_oz,
            uz: r.title_uz,
            qr: r.title_qr
          }
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }

      this.loading = false
    },
    // tabPaneChangeHandler(arg) {
    //   this.tabPane = arg
    // },

    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab === "uz" ? "oz" : "uz",
          methodName = this.langTab === "uz" ? "toKirill" : "toLatin"

        if (this.form.title[from]) {
          this.form.title[to] = this[methodName](this.form.title[from])
        }
      } catch (error) {
        console.log("translitAction error", error)
      }
    },

    async submit() {
      this.pending = true
      try {
        let newData = cloneDeep(this.form)
        newData = {
          ...newData,
          title_ru: newData.title.ru,
          title_uz: newData.title.uz,
          title_oz: newData.title.oz,
          title_en: newData.title.en,
          title_qr: newData.title.qr
        }
        delete newData.title
        let f = new FormData()

        Object.keys(newData).forEach((key) => {
          f.append(key, newData[key])
        })

        const req = {
          method: this.form.id ? "update" : "create",
          id: this.form.id || null
        }
        const r = await this.$store.dispatch(`faq/${req.method}ThemeAction`, {
          id: req.id,
          data: f
        })

        // console.log(r);

        if (r && r.id) {
          this.$message.success("Данные сохранены")
          this.$router.push({ name: "faq" })
        }
      } catch (e) {
        console.log(e)
        this.pending = false
      }

      this.pending = false
    }
  }
}
</script>
